
import { useState } from '@wordpress/element';
import { InspectorControls } from '@wordpress/block-editor';
import { TabPanel } from "@wordpress/components";
import ProModal from './ProModal';
import { tabs } from '../../../Const/options';

import General from './General/General';
import Style from './Style/Style';
import Patterns from './Patterns/Patterns';

const Settings = (props) => {
    const { clientId, attributes, setAttributes, addSlider, removeSlider, duplicateSlider, activeIndex, setActiveIndex } = props;
    const { sliders, title, titleFCaption, slideInnerGap, titleTypo, titleColor, descTypo, descColor, titleMargin, descMargin, arrow, indicator, SliderOverly, options, height, sliderHeight, slideInnerGapDevice, borderRadius, margin, animation, position, arrowWidth, deviceArrowWidth, arrowHeight, deviceArrowHeight, arrowRadius, arrowStyle, btnColors, btnHovColors, btnTypo, btnPadding, btnBorder, btnRadius, direction, isPremium, titleAnimation, descAnimation, btnAnimation, isMouseWheel, isArrowFollowSlide, isMouseDrag, isLazyLoad } = attributes;

    const [proModalOpen, setProModalOpen] = useState(false);


    const updateObject = (attr, key, val) => {
        const newAttr = { ...attributes[attr] };
        newAttr[key] = val;
        setAttributes({ [attr]: newAttr })
    }

    const generalProps = { isPremium, attributes, setAttributes, addSlider, removeSlider, duplicateSlider, activeIndex, setActiveIndex, sliders, title, titleFCaption, slideInnerGap, options, height, sliderHeight, slideInnerGapDevice, animation, position, arrowStyle, isMouseWheel, isArrowFollowSlide, isMouseDrag, isLazyLoad, direction, setProModalOpen, updateObject, arrow, indicator, }

    const styleProps = { titleTypo, titleColor, descTypo, descColor, titleMargin, descMargin, SliderOverly, borderRadius, margin, deviceArrowWidth, arrowHeight, deviceArrowHeight, arrowRadius, btnColors, btnHovColors, btnTypo, btnPadding, btnBorder, btnRadius, titleAnimation, descAnimation, btnAnimation, setAttributes, setProModalOpen, isPremium, updateObject, arrow, arrowWidth, indicator }

    const patternsProps = { isPremium, clientId, setProModalOpen }

    return <> <InspectorControls style={{ marginBottom: "40px" }}>
        <TabPanel className="bPlTabPanel bsb-tab-panel" activeClass="activeTab" tabs={tabs}>
            {(tab) => <>
                {'General' == tab.name && <>
                    <General {...generalProps} />
                </>}

                {'style' == tab.name && <>
                    <Style {...styleProps} />
                </>}
                {"patterns" === tab.name && <>

                    <Patterns {...patternsProps} />
                </>}
            </>}
        </TabPanel>
    </InspectorControls>
        <ProModal setProModalOpen={setProModalOpen} proModalOpen={proModalOpen} />
    </>
}
export default Settings;